module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('HTMLHeader'), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('HTMLMenu'), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "floating-buttons"
  }, [_c('router-link', {
    staticClass: "fl-button grey",
    attrs: {
      "to": {
        path: '/groups/'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-left"
  })]), _vm._v(" "), _c('button', {
    staticClass: "fl-button",
    attrs: {
      "disabled": _vm.is_save,
      "type": "button"
    },
    on: {
      "click": _vm.save
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  })])], 1), _vm._v(" "), _c('h1', [_vm._v("Csoport")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('inputbox', {
    attrs: {
      "id": "name",
      "label": "Megnevezés",
      "errors": _vm.errors,
      "name": "name"
    },
    model: {
      value: (_vm.form.name),
      callback: function($$v) {
        _vm.$set(_vm.form, "name", $$v)
      },
      expression: "form.name"
    }
  }), _vm._v(" "), _c('div', [_c('h2', [_vm._v("Csatolt elemek")]), _vm._v(" "), (_vm.selected_elements.length > 0) ? _c('div', {
    staticClass: "selected-items-list"
  }, _vm._l((_vm.selected_elements), function(element) {
    return _c('div', {
      staticClass: "item"
    }, [_c('button', {
      staticClass: "button small",
      on: {
        "click": function($event) {
          return _vm.removeElement(element.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })]), _vm._v("\n                  " + _vm._s(element.name) + "\n                ")])
  }), 0) : _c('div', {
    staticClass: "normal-text"
  }, [_vm._v("\n                Nem található csatolt elem.\n              ")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('comboboxV2', {
    attrs: {
      "change": _vm.changeGroupType,
      "id": "group_type_id",
      "label": "Csoport típusa",
      "errors": _vm.errors,
      "name": "group_type_id",
      "options": _vm.group_types
    },
    model: {
      value: (_vm.form.type_id),
      callback: function($$v) {
        _vm.$set(_vm.form, "type_id", $$v)
      },
      expression: "form.type_id"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('comboboxV2', {
    attrs: {
      "change": _vm.elementTypeChange,
      "id": "element_type_id",
      "label": "Csoporton belül engedélyezett elem típusok",
      "errors": _vm.errors,
      "name": "element_type_id",
      "options": _vm.enabled_element_types
    },
    model: {
      value: (_vm.element_type_id),
      callback: function($$v) {
        _vm.element_type_id = $$v
      },
      expression: "element_type_id"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "selected-items-list"
  }, _vm._l((_vm.elements), function(element) {
    return (_vm.showElement(element.id)) ? _c('div', {
      staticClass: "item"
    }, [_c('button', {
      staticClass: "button small",
      on: {
        "click": function($event) {
          return _vm.addElement(element.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-chevron-left"
    })]), _vm._v("\n                " + _vm._s(element.name) + "\n              ")]) : _vm._e()
  }), 0)], 1)])])])], 1), _vm._v(" "), _c('HTMLFooter'), _vm._v(" "), _c('ProgressInfo', {
    attrs: {
      "show": _vm.is_save
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cc16df3a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/group.vue
// module id = 328
// module chunks = 0